export enum AuditEvent {
  TenantCreate = 'Tenant:Create',
  TenantDelete = 'Tenant:Delete',
  TenantUpdate = 'Tenant:Update',
  UserCreate = 'User:Create',
  UserUpdate = 'User:Update',
  UserDelete = 'User:Delete',
  UserPasswordReset = 'Credentials:PasswordResetRequested',
  UserOtpCodeSent = 'Credentials:OtpCodeRequested',
  UserLocked = 'LocalUser:Lock',
  UserLockWarning = 'LocalUser:LockWarning',
  UserLockExpired = 'LocalUser:LockExpired',
  TaniumInstanceCreate = 'TaniumInstance:Create',
  TaniumInstanceDelete = 'TaniumInstance:Delete',
  DomainCreate = 'Domain:Create',
  DomainDelete = 'Domain:Delete',
  IdpCreate = 'Idp:Create',
  IdpUpdate = 'Idp:Update',
  IdpDelete = 'Idp:Delete',
  GettingStartedEmailSent = 'GettingStartedEmail:Sent',
  LinkedInstanceEmailSent = 'LinkedInstanceEmail:Sent',
  UnlinkedInstanceEmailSent = 'UnlinkedInstanceEmail:Sent',
  IdpCertExpirationEmailSent = 'IdpCertExpirationEmail:Sent',
}

export interface AuditHistoryEventBase {
  username?: string;
  event: AuditEvent;
  createdAt: number;
  message: string;
  email?: string;
  userId?: string;
  tenantId?: string;
  details: any;
}

export interface AuditHistoryResponse {
  data: AuditHistoryEventBase[];
  nextPageCursor: string;
  totalCount: number;
}

export interface AuditHistoryRequest {
  // startTime and endTime should be UTC timestamps
  startTime: number;
  endTime: number;
  limit: number;
  cursor?: string;
  user?: string;
  event?: string;
}
